import { z } from "zod";

export const SyncUsersSchema = z.object({
    users: z.array(z.string())
});

export type SyncUsersFormData = z.infer<typeof SyncUsersSchema>;